import type { TaskCreateInput, TaskUpdateInput } from '@stoplord/shared';
import { api } from '@/lib/api';
import type { Task, TaskComment, TaskDetail } from './types';

export const tasksApi = {
  list: (q: Record<string, string | number | undefined>) => api.page<Task>('/tasks', q),
  get: (id: string) => api.get<TaskDetail>(`/tasks/${id}`),
  create: (body: TaskCreateInput) => api.post<Task>('/tasks', body),
  update: (id: string, body: TaskUpdateInput) => api.patch<Task>(`/tasks/${id}`, body),
  status: (id: string, status: string, note?: string) => api.post<Task>(`/tasks/${id}/status`, { status, note }),
  review: (id: string, decision: 'approve' | 'reopen', note?: string) => api.post<Task>(`/tasks/${id}/review`, { decision, note }),
  assign: (id: string, assigneeIds: string[]) => api.post<Task>(`/tasks/${id}/assign`, { assigneeIds }),
  addItem: (id: string, text: string) => api.post(`/tasks/${id}/checklist`, { text }),
  toggleItem: (id: string, itemId: string, done: boolean) => api.patch(`/tasks/${id}/checklist/${itemId}`, { done }),
  removeItem: (id: string, itemId: string) => api.delete(`/tasks/${id}/checklist/${itemId}`),
  comment: (id: string, body: string) => api.post<TaskComment>(`/tasks/${id}/comments`, { body }),
  remove: (id: string) => api.delete(`/tasks/${id}`),
};
